// extracted by mini-css-extract-plugin
export default {"main":"DropDownMenu_main__wR29J","header":"DropDownMenu_header__FCZs+","dropdownImage":"DropDownMenu_dropdownImage__q-ohq","children":"DropDownMenu_children__fQAEr"};